(function(factory) {
    if (window.define) {
        define('lib/onload', function(require, exports) {
            exports = factory();
        });
    }

    factory();
})(function() {
    var onLoad = function(callback) {
        if (onLoad.__loaded) {
            callback();
        } else {
            var success = function() {
                onLoad.__loaded = true;
                callback();
            };

            if (document.readyState === 'complete') {
                success();
            } else {
                if (window.addEventListener) {
                    window.addEventListener('load', success, false);
                } else if (window.attachEvent) {
                    window.attachEvent('onload', success);
                }
            }
        }
    };

    onLoad.on = function(name, cb) {
        if (onLoad['_emitted__' + name] == true) {
            cb(name);
        }
        (onLoad['_' + name] || (onLoad['_' + name] = [])).push(cb);
    };

    onLoad.emit = function(name) {
        onLoad['_emitted__' + name] = true;

        if (onLoad['_' + name]) {
            for (var cbs = onLoad['_' + name], i = 0, cb, len = cbs.length; i < len; i++) {
                if (typeof(cb = cbs[i]) === 'function') {
                    cb(name);
                }
            }
        }
    };

    window.onLoad = onLoad;

    return onLoad;
});
